import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        pageName="SERVICES / DATA CONSUMPTION, REPORTING & ANALYTICS"
        pageIntro="Transform enterprise data into actionable insights with robust reporting, BI, and analytics solutions."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "reporting-bi",
            title: "Reporting & BI",
            desc: "Scalable BI pipelines deliver real-time, high-performance reporting with fault-tolerant analytics.",
            technologies:
              "Power BI, Tableau, Apache Spark, Kafka, Airflow, Snowflake, Redshift",
            features: [
              "Scalable ETL/ELT pipelines",
              "Real-time data integration",
              "High-performance visualizations",
              "Fault-tolerant architecture",
              "Petabyte-scale processing",
              "Cross-functional unification",
            ],
            impact: "70% reduced reporting time, 30% improved decision-making",
            caseStudy: {
              client: "Global Retail Corporation",
              challenge:
                "Fragmented data sources and slow reporting pipelines delayed customer and sales insights, impacting strategic decisions.",
              solution:
                "NucleusTeq engineered a Spark-based reporting pipeline with Power BI, integrating ERP and CRM data via Kafka for real-time, interactive dashboards.",
              outcome:
                "Reduced reporting time by 65% and improved decision-making speed by 28%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with real-time sales analytics and interactive charts, featuring Power BI icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with real-time BI and reporting",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "custom-dashboards",
            title: "Custom Dashboard Development",
            desc: "High-performance custom dashboards provide real-time, tailored analytics for enterprise stakeholders.",
            technologies: "Power BI, Tableau, Superset",
            features: [
              "Real-time rendering",
              "Custom visualizations",
              "Scalable integration",
              "Interactive interfaces",
              "Fault-tolerant design",
              "Cross-platform support",
            ],
            impact: "60% faster insights, 30% improved visibility",
            caseStudy: {
              client: "Financial Services Firm",
              challenge:
                "Generic dashboards lacked tailored insights for financial analytics, slowing decision-making.",
              solution:
                "NucleusTeq developed Tableau-based custom dashboards, integrating financial data for real-time, stakeholder-specific insights.",
              outcome:
                "Reduced insight delivery time by 55% and improved visibility by 28%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard with custom analytics and real-time data, featuring Tableau icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Financial, data-driven, digital art, 800x400px",
              altText:
                "Financial dashboard with custom analytics visualizations",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "self-service-bi",
            title: "Self-Service BI Implementation",
            desc: "Scalable self-service BI platforms empower users with automated, real-time analytics access.",
            technologies: "Looker, Qlik Sense, Superset",
            features: [
              "Scalable architecture",
              "Automated processing",
              "Intuitive interfaces",
              "Real-time access",
              "Secure governance",
              "High-throughput reporting",
            ],
            impact: "50% reduced IT dependency, 40% faster reporting",
            caseStudy: {
              client: "Retail Chain",
              challenge:
                "Heavy IT reliance for BI reports slowed business decisions and increased costs.",
              solution:
                "NucleusTeq implemented a Looker-based self-service BI platform, enabling real-time report generation with minimal IT support.",
              outcome:
                "Reduced IT dependency by 45% and sped up reporting by 38%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard with self-service BI tools and real-time reports, featuring Looker icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Retail, data-driven, digital art, 800x400px",
              altText: "Retail dashboard with self-service BI platform",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "cross-functional-reporting",
            title: "Cross-Functional Reporting",
            desc: "Integrated reporting systems unify departmental data for real-time, scalable cross-functional insights.",
            technologies: "Power BI, Tableau, Snowflake",
            features: [
              "Cross-departmental integration",
              "Real-time pipelines",
              "Scalable unification",
              "Unified KPI dashboards",
              "Secure sharing",
              "Low-latency insights",
            ],
            impact: "60% improved reporting accuracy, 25% faster insights",
            caseStudy: {
              client: "Logistics Provider",
              challenge:
                "Siloed departmental data hindered unified operational insights, delaying decisions.",
              solution:
                "NucleusTeq developed a Power BI-based cross-functional reporting system, integrating logistics data with Snowflake pipelines.",
              outcome:
                "Improved reporting accuracy by 58% and reduced insight time by 22%.",
            },
            imagePrompt: {
              description:
                "A logistics dashboard with unified operational insights, featuring Power BI icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Logistics, analytical, digital art, 800x400px",
              altText: "Logistics dashboard with cross-functional reporting",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "bi-strategy",
            title: "BI Strategy Consulting",
            desc: "Engineering-driven BI strategies optimize pipelines, aligning insights with KPIs for maximum ROI.",
            technologies: "Power BI, Tableau, strategic frameworks",
            features: [
              "Pipeline optimization",
              "KPI-aligned roadmaps",
              "Stakeholder workshops",
              "Scalable strategies",
              "ROI-focused planning",
              "Technical audits",
            ],
            impact: "40% improved analytics impact, 30% higher ROI",
            caseStudy: {
              client: "Global Consumer Goods Company",
              challenge:
                "Misaligned BI pipelines limited revenue growth insights, reducing strategic impact.",
              solution:
                "NucleusTeq conducted Tableau-based workshops to optimize BI pipelines, aligning analytics with revenue KPIs.",
              outcome:
                "Improved analytics impact by 35% and increased ROI by 28%.",
            },
            imagePrompt: {
              description:
                "A consumer goods dashboard with KPI-aligned analytics, featuring Tableau icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Consumer goods, analytical, digital art, 800x400px",
              altText: "Consumer goods dashboard with BI strategy",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "generative-bi",
            title: "Generative BI",
            desc: "AI-driven BI pipelines deliver automated predictive and prescriptive insights for enterprise agility.",
            technologies: "TensorFlow, Azure ML, Power BI, Superset, Python",
            features: [
              "AI-driven insights",
              "Automated pipelines",
              "Prescriptive recommendations",
              "Scalable models",
              "Real-time processing",
              "System integration",
            ],
            impact: "25% higher sales, 40% faster insights",
            caseStudy: {
              client: "Online Retail Company",
              challenge:
                "Manual analytics limited sales forecasting and responsiveness.",
              solution:
                "NucleusTeq engineered a TensorFlow-based generative BI pipeline for automated predictive sales insights.",
              outcome:
                "Increased sales by 22% and reduced insight time by 38%.",
            },
            imagePrompt: {
              description:
                "An online retail dashboard with AI-driven predictive insights, featuring TensorFlow icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Retail, analytical, digital art, 800x400px",
              altText: "Retail dashboard with generative BI insights",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "predictive-analytics",
            title: "Predictive Analytics Solutions",
            desc: "Scalable predictive models with fault-tolerant pipelines ensure accurate forecasting for enterprises.",
            technologies: "TensorFlow, Azure ML, Python, Apache Spark",
            features: [
              "Scalable models",
              "Fault-tolerant pipelines",
              "Real-time forecasting",
              "System integration",
              "High-accuracy algorithms",
              "Dynamic processing",
            ],
            impact: "30% improved forecast accuracy, 25% higher sales",
            caseStudy: {
              client: "Manufacturing Company",
              challenge:
                "Inaccurate demand forecasts disrupted production planning.",
              solution:
                "NucleusTeq engineered a Spark-based predictive model, integrated with manufacturing systems for accurate forecasting.",
              outcome:
                "Improved forecast accuracy by 28% and increased sales efficiency by 20%.",
            },
            imagePrompt: {
              description:
                "A manufacturing dashboard with demand forecasts, featuring Spark icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Manufacturing, analytical, digital art, 800x400px",
              altText:
                "Manufacturing dashboard with predictive analytics solutions",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "bi-optimization",
            title: "BI Optimization Consulting",
            desc: "Optimize BI pipelines for performance, scalability, and fault tolerance, ensuring efficient analytics workflows.",
            technologies: "Apache Spark, Python, Superset",
            features: [
              "Performance tuning",
              "Fault-tolerant design",
              "Scalable workflows",
              "Error detection",
              "High-throughput processing",
              "Pipeline audits",
            ],
            impact: "50% faster analytics, 25% reduced errors",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Suboptimal BI pipelines caused delays and errors in network analytics.",
              solution:
                "NucleusTeq optimized Spark-based BI pipelines with Superset, implementing real-time tuning and error reduction.",
              outcome: "Reduced analytics time by 45% and errors by 22%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with optimized BI pipeline metrics, featuring Spark icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Telecom, analytical, digital art, 800x400px",
              altText: "Telecom dashboard with BI pipeline optimization",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-mesh-architecture",
            title: "Data Mesh Architecture",
            desc: "Decentralized, scalable data mesh enables real-time analytics across distributed enterprise systems.",
            technologies: "Domain-Driven Design, Kafka, Kubernetes",
            features: [
              "Decentralized architecture",
              "Real-time access",
              "Fault-tolerant frameworks",
              "Scalable data flows",
              "Business agility",
              "Secure integration",
            ],
            impact: "80% improved data availability, 30% faster access",
            caseStudy: {
              client: "Media Company",
              challenge:
                "Centralized data systems slowed content team analytics.",
              solution:
                "NucleusTeq engineered a Kafka-based data mesh, enabling decentralized, real-time content analytics.",
              outcome:
                "Improved data availability by 75% and reduced access time by 28%.",
            },
            imagePrompt: {
              description:
                "A media dashboard with decentralized data streams, featuring Kafka icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Media, technical, digital art, 800x400px",
              altText: "Media dashboard with data mesh architecture",
            },
            buttunData: {
              buttonText: "Discover AI-Powered Innovation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "api-development",
            title: "API Development",
            desc: "Scalable REST/GraphQL APIs enable real-time data consumption with secure, low-latency connectivity.",
            technologies: "Spring Boot, Node.js, REST, GraphQL",
            features: [
              "Scalable APIs",
              "Real-time access",
              "Fault-tolerant designs",
              "Secure governance",
              "Low-latency connectivity",
              "Enterprise integration",
            ],
            impact: "60% faster data connectivity, 20% reduced latency",
            caseStudy: {
              client: "Financial Institution",
              challenge:
                "Slow data connectivity hindered real-time financial analytics.",
              solution:
                "NucleusTeq developed Spring Boot-based REST APIs for secure, low-latency analytics access.",
              outcome: "Reduced connectivity time by 55% and latency by 18%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard with API-driven analytics, featuring Spring Boot icons. Use blue and white (#007BFF, #FFFFFF).",
              style: "Financial, technical, digital art, 800x400px",
              altText: "Financial dashboard with API-driven analytics",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "microservices-integration",
            title: "Microservices Integration",
            desc: "Microservices frameworks enable scalable, real-time data consumption across distributed enterprise systems.",
            technologies: "Kubernetes, Spring Boot, Node.js",
            features: [
              "Microservices frameworks",
              "Real-time integration",
              "Fault-tolerant architectures",
              "High availability",
              "Scalable connectivity",
              "Secure access",
            ],
            impact: "50% improved scalability, 30% reduced downtime",
            caseStudy: {
              client: "Healthcare Provider",
              challenge:
                "Distributed systems lacked scalable integration for analytics.",
              solution:
                "NucleusTeq engineered a Kubernetes-based microservices framework for seamless healthcare analytics.",
              outcome:
                "Improved scalability by 48% and reduced downtime by 25%.",
            },
            imagePrompt: {
              description:
                "A healthcare dashboard with microservices-driven analytics, featuring Kubernetes icons. Use blue gradient (#E6F0FA to #007BFF).",
              style: "Healthcare, technical, digital art, 800x400px",
              altText: "Healthcare dashboard with microservices integration",
            },
            buttunData: {
              buttonText: "See Your Data in Action",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Request a Demo",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
